function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export async function subscribeAdminPush(api) {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    throw new Error("Push-meldingen worden niet ondersteund door deze browser.");
  }
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Je hebt meldingen geweigerd. Sta ze toe in je browser.");
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/admin/push/vapid");
  if (!data.public_key) throw new Error("Push is niet geconfigureerd op de server.");
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.public_key),
  });
  await api.post("/admin/push/subscribe", { subscription: sub.toJSON ? sub.toJSON() : sub });
}

export async function unsubscribeAdminPush(api) {
  if (!("serviceWorker" in navigator)) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    try { await api.post("/admin/push/unsubscribe", { subscription: sub.toJSON() }); } catch (e) {}
    await sub.unsubscribe();
  }
}
